'use client'

import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { authClient } from '@/frontend/auth/auth-client'
import { Button } from '@/frontend/design-system/actions/Button'
import { showErrorToast } from '@/frontend/design-system/feedback/Toaster/ToasterError'
import { ErrorMessage, Field, Label } from '@/frontend/design-system/forms/Fieldset'
import { Input } from '@/frontend/design-system/forms/Input'
import type { ForgotPasswordSchema } from '../_schemas/forgotPassword'

export function ForgotPasswordForm() {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<ForgotPasswordSchema>({ mode: 'onSubmit' })

  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (data: ForgotPasswordSchema) => {
    setIsLoading(true)

    const { error: resetError } = await authClient.requestPasswordReset({
      email: data.email,
      redirectTo: '/auth/new-password'
    })

    if (resetError) {
      showErrorToast(resetError.message ?? 'Wystąpił błąd. Spróbuj ponownie.')
      setIsLoading(false)
      return
    }

    toast.success(
      'Jeśli podany adres email istnieje w naszym systemie, wysłaliśmy link do resetu hasła.'
    )
    setIsLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='space-y-6'>
      <Field>
        <Label>Adres email</Label>
        <Input
          type='email'
          placeholder='email@example.com'
          {...register('email', { required: 'Wpisz adres email' })}
        />
        {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
      </Field>

      <Button type='submit' color='algoprimary' className='w-full' disabled={isLoading}>
        {isLoading ? 'Wysyłanie...' : 'Wyślij link'}
      </Button>
    </form>
  )
}
